var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useContext } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { AppleButton, FaceBookButton, GoogleButton } from '../buttons';
import { AuthModalContext } from '../providers/auth-modal-provider';
import { LeftPanel } from './left-pane';
import { SignUpTerms } from './signup-terms';
import { SocialSignUpFormStyle } from './social-signup-form-style';
import { useAppleLogin } from './use-apple-login';
import { useFacebookLogin } from './use-facebook-login';
import { useGoogleLogin } from './use-google-login';
export var SocialSignUpForm = function (_a) {
    var data = _a.data, redirectTo = _a.redirectTo;
    var authContext = useContext(AuthModalContext);
    var appleSignUp = useAppleLogin(redirectTo).appleSignUp;
    var _b = useFacebookLogin(redirectTo), facebookSignup = _b.facebookSignup, isFacebookLoading = _b.isFacebookLoading;
    var _c = useGoogleLogin(redirectTo), googleSignup = _c.googleSignup, isGoogleLoading = _c.isGoogleLoading;
    var handleLoginLink = function (event) {
        event.preventDefault();
        authContext.api.updateIsLogin(true);
    };
    var handleSignUpLink = function (event) {
        event.preventDefault();
        authContext.api.updateIsEmailSignUp(true);
    };
    var handleFacebookSignUp = function (event) {
        event.preventDefault();
        facebookSignup();
    };
    var handleGoogleSignUp = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    return [4, googleSignup()];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var handleAppleSignUp = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    return [4, appleSignUp()];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var intl = useIntl();
    var socialSignUpFormMessages = defineMessages({
        facebookButtonMessage: {
            id: 'components.authentication.social-sign-up-form.btn.facebook',
            description: 'Text for "Continue with Facebook" button',
            defaultMessage: 'Continue with Facebook',
        },
        googleButtonMessage: {
            id: 'components.authentication.social-sign-up-form.btn.google',
            description: 'Text for "Continue with Google" button',
            defaultMessage: 'Continue with Google',
        },
        appleButtonMessage: {
            id: 'components.authentication.social-sign-up-form.btn.apple',
            description: 'Text for "Continue with Apple" button',
            defaultMessage: 'Continue with Apple',
        },
        formSeparatoreparatorMessage: {
            id: 'components.authentication.social-sign-up-form.separator',
            description: 'Text use to separate two options for sign up: using a social media account OR using email and password.',
            defaultMessage: 'or',
        },
        signUpButtonMessage: {
            id: 'components.authentication.social-sign-up-form.btn.sign-up',
            description: 'Text for sign up button',
            defaultMessage: 'Sign Up Using Email',
        },
        alreadyMemberMessage: {
            id: 'components.authentication.social-sign-up-form.question',
            description: 'Already a member question',
            defaultMessage: 'Already a member?',
        },
        signInButtonMessage: {
            id: 'components.authentication.social-sign-up-form.btn.sign-in',
            description: 'Text for sign in button',
            defaultMessage: 'Sign In',
        },
    });
    return (React.createElement(SocialSignUpFormStyle, null,
        React.createElement(LeftPanel, { data: data }),
        React.createElement("div", { className: "right-pane" },
            React.createElement("div", { className: "skillshare-logo" }),
            React.createElement("div", { className: "form-wrapper" },
                React.createElement(FaceBookButton, { isFacebookLoading: isFacebookLoading, text: intl.formatMessage(socialSignUpFormMessages.facebookButtonMessage), onClick: handleFacebookSignUp }),
                React.createElement(GoogleButton, { isGoogleLoading: isGoogleLoading, text: intl.formatMessage(socialSignUpFormMessages.googleButtonMessage), onClick: handleGoogleSignUp }),
                React.createElement(AppleButton, { text: intl.formatMessage(socialSignUpFormMessages.appleButtonMessage), onClick: handleAppleSignUp }),
                React.createElement("div", { className: "email-sign-up" },
                    React.createElement("div", { className: "form-separator" },
                        React.createElement("p", null, intl.formatMessage(socialSignUpFormMessages.formSeparatoreparatorMessage))),
                    React.createElement("button", { className: "link", onClick: handleSignUpLink }, intl.formatMessage(socialSignUpFormMessages.signUpButtonMessage))),
                React.createElement("div", { className: "login" },
                    intl.formatMessage(socialSignUpFormMessages.alreadyMemberMessage),
                    ' ',
                    React.createElement("button", { className: "link", onClick: handleLoginLink }, intl.formatMessage(socialSignUpFormMessages.signInButtonMessage))),
                React.createElement("div", { className: "form-separator" },
                    React.createElement("p", null)),
                React.createElement(SignUpTerms, null)))));
};
//# sourceMappingURL=social-signup-form.js.map